import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CatalogPageComponent} from "./catalog-page.component";
import {CatalogComponent} from "./components/catalog/catalog.component";
import {CatalogItemComponent} from "./components/catalog-item/catalog-item.component";
import {CatalogCategoryComponent} from "./components/catalog-category/catalog-category.component";
import {CatalogFormComponent} from "./components/catalog-form/catalog-form.component";
import {CatalogFieldComponent} from "./components/catalog-field/catalog-field.component";
import {CoreModule} from "../../core/core.module";
import {SharedModule} from "../../shared/shared.module";
import {RouterModule} from "@angular/router";
import { QuestionModalComponent } from './components/question-modal/question-modal.component';
import {DialogModule} from "@syncfusion/ej2-angular-popups";

@NgModule({
  declarations: [
    CatalogPageComponent,
    CatalogComponent,
    CatalogItemComponent,
    CatalogCategoryComponent,
    CatalogFormComponent,
    CatalogFieldComponent,
    QuestionModalComponent,
  ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        RouterModule,
        DialogModule,
    ],
  exports: [
    CatalogPageComponent,
    CatalogComponent,
    CatalogCategoryComponent,
    CatalogItemComponent,
    CatalogFormComponent,
    CatalogFieldComponent,
  ]
})
export class CatalogPageModule { }
